var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphOpportunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 30 30",
    width: "100%",
    xmlSpace: "preserve",
    stroke: "#5990e4",
    fill: "#5990e4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "nonzero",
    id: "ClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9L21 9L21 9L21 21L21 21L9 21L9 21L9 9L9 9Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ClipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.5008L10.5 12.3008L19.5 12.3008L19.5 19.5008L10.5 19.5008Z",
    fillRule: "nonzero",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5C17 15.0304 16.7893 15.5391 16.4142 15.9142C16.0391 16.2893 15.5304 16.5 15 16.5C14.4696 16.5 13.9609 16.2893 13.5858 15.9142C13.2107 15.5391 13 15.0304 13 14.5",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17 11.4696 16.7893 10.9609 16.4142 10.5858C16.0391 10.2107 15.5304 10 15 10C14.4696 10 13.9609 10.2107 13.5858 10.5858C13.2107 10.9609 13 11.4696 13 12",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphOpportunityIcon);
export default __webpack_public_path__ + "static/media/graphOpportunityIcon.d08eb25b05f581a3cce6909682e49caf.svg";
export { ForwardRef as ReactComponent };